import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const SESSION_ID_KEY = "tsarena_admin_session_id";
const IP_KEY         = "tsarena_admin_ip";

// Called once at login — generates sessionId and fetches IP
export async function initAdminSession() {
  const sessionId = "sess_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);

  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    sessionStorage.setItem(IP_KEY, data.ip);
  } catch {
    sessionStorage.setItem(IP_KEY, "unknown");
  }

  return sessionId;
}

// Call for every admin action
export async function logAdminAction(action, details = "") {
  const sessionId = sessionStorage.getItem(SESSION_ID_KEY) || "unknown";
  const ipAddress = sessionStorage.getItem(IP_KEY)         || "unknown";

  try {
    await addDoc(collection(db, "admin_logs"), {
      action,
      details,
      sessionId,
      ipAddress,
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    console.error("[adminLogger] Failed to write log:", e.message);
  }
}
